import React, { useState, useEffect } from 'react';
import {ChainSorter} from 'chainsorter';

import Filterable from '../components/ui/filter/Filterable.js';
import HarvestForm from '../components/harvest/interface.js';
import HarvestSummary from '../components/harvest/record.js';
import Loadable from '../components/ui/loading/Loadable.js';
import convert from 'convert-units';
import api from '../api/index.js';

import './Dashboard.scss'

export default (props) => {

	const [data, setData] = useState(false);
	const [units, setUnits] = useState(false);
	const [invoiceCount, setInvoiceCount] = useState(false);
	const [totalpounds, setTotalpounds] = useState(0);

	const refresh = async () => {
		// Hit the API
		try {
			setUnits(await api.settings.get('display_units_mass'));
			let d = await api.get('harvests?from=' + props.dateStart.api() + '&until=' + props.dateEnd.api());
			ChainSorter(d).desc('date').sort();
			setData(d);
			let c = {};
			for(let i in d) {
				if (!c.hasOwnProperty(d[i].InvoiceNumber))
					c[d[i].InvoiceNumber] = 0;
				c[d[i].InvoiceNumber] += 1;
			}
			setInvoiceCount(c);
		} catch(e) {
			api.handleExceptions(e);
		};
	}


	const onDelete = async (harvestId) => {
		try {
			await api.del('harvests/' + harvestId);
			refresh();
		} catch(e) {
			api.handleExceptions(e);
		};
	}


	useEffect(()=>{
		refresh();
	}, [props.dateStart, props.dateEnd])


	const onSaved = () => {
		refresh();
		return true;
	}


	const filter = (data, filterstring) => {
		let filtered = [];
		let weight = 0;
		const f = filterstring.toLowerCase();
		for(let i in data) {
			let summary = 'harvest record ' + String(data[i].HarvestID)
				+ ' date: ' + data[i].Date
				+ ' invoice number: ' + data[i].InvoiceNumber
				+ ' processor: ' + data[i].ProcessorName
				+ ': ' + data[i].GradeName;
			let fw = 0;
			for(let t in data[i].fields) {
				let val = Math.round(convert(parseFloat(data[i].fields[t].Weight)).from('kg').to(units));
				fw += val;
				summary += ' ' + data[i].fields[t].FarmName + ': field ' + data[i].fields[t].FieldNumber + ' weight ' + val + units;
			}
			if (summary.toLowerCase().includes(f)) {
				weight += fw;
				filtered.push(data[i]);
				continue;
			}
		}
		setTotalpounds(weight);
		return filtered;
	}


	return <div className="HarvestRecords Specific">
			<h1>Harvest Records ({totalpounds.toLocaleString()} {units}s)</h1>
			<Loadable ready={data !== false} className="records">
				<Filterable 
					summaryComponent={HarvestSummary}
					addForm={HarvestForm}
					onAddSubmit={onSaved}
					children={data}
					onSelect={false}
					type="harvest record"
					passProps={{onDelete: onDelete, refresh: ()=>{refresh()}, invoiceCount: invoiceCount}}
					filter={filter}
				/>
			</Loadable>
		</div>;
}